export class DocumentVersionDetailsForBulkUserReplacement {
    documentNumber?: string;
    documentVersion?: number;

    constructor(number: string, version: number){
        this.documentNumber = number;
        this.documentVersion = version;
    }
}